import React from "react";

const ModuleRadioOption = ({ name, checked, onChange, plain = false, children }) => (
  <label className={[checked && "is-checked", plain && "is-plain"].filter(Boolean).join(" ")}>
    <input type="radio" name={name} checked={checked} onChange={onChange} />
    <span>{children}</span>
  </label>
);

export default ModuleRadioOption;
